import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { PageHeader } from '@ui/layout/Layout/components';
import SSearchInput from '@ui/components/common/SSearchInput';
import { FiltersDiscardButton } from '@ui/components/common/buttons';
import SystemsDataGrid from './components/SystemsDataGrid';
import { SystemDialog } from '@ui/components/Dialogs';
import { systemApi } from '@application/api/endpoints/system-api';
import useAsyncEffect from 'use-async-effect';
import { convertToLocalTimezone } from '@application/utilities/date-time-formater';
const Systems = () => {
    const [isFilterEnabled, setIsFilterEnabled] = useState(false);
    const [systemDetails, setSystemDetails] = useState();
    const [systemDialog, setSystemDialog] = useState({
        show: false,
        variant: '',
        title: ''
    });
    const [systemQuery, setSystemQuery] = useState({
        pageNumber: 1,
        pageSize: 10
    });
    const initialFilters = {
        search: '',
        systemName: '',
        systemType: '',
        lastLocation: '',
        lastInfoReceivedFilter: '',
        asset: '',
        description: '',
        isActive: ''
    };
    const initialQueryState = {
        searchTerm: '',
        systemNameFilter: '',
        systemTypeFilter: '',
        description: '',
        locationFilter: '',
        lastInfoReceivedFilter: null,
        assetFilter: '',
        statusFilter: undefined // or false if you want to default it
    };
    const [filters, setFilters] = useState(initialFilters);
    const handleCloseSystemDialog = () => {
        setSystemDialog((prev) => ({ ...prev, show: false, title: '', variant: '' }));
    };
    const handleEnableFilters = () => {
        setIsFilterEnabled(true);
    };
    const DiscardAndCloseFilters = () => {
        setIsFilterEnabled(false);
        setFilters(initialFilters);
        setSystemQuery(initialQueryState);
    };
    const mapFiltersToQuery = (filters) => {
        return {
            searchTerm: filters.search || undefined,
            systemNameFilter: filters?.systemName?.trim() || undefined,
            systemTypeFilter: filters?.systemType?.trim() || undefined,
            locationFilter: filters?.lastLocation?.trim() || undefined,
            description: filters?.description?.trim() || undefined,
            lastInfoReceivedFilter: filters.lastInfoReceived
                ? convertToLocalTimezone(filters.lastInfoReceived)
                : undefined,
            assetFilter: filters?.asset?.trim() || undefined,
            statusFilter: filters.isActive?.toLowerCase() === 'active'
                ? true
                : filters.status?.toLowerCase() === 'inactive'
                    ? false
                    : undefined
        };
    };
    useAsyncEffect(async () => {
        await getFilteredSystemDetail();
    }, [systemQuery]);
    useEffect(() => {
        setSystemQuery(() => ({
            ...mapFiltersToQuery(filters)
        }));
    }, [filters]);
    const getFilteredSystemDetail = async () => {
        try {
            const response = await systemApi.getFilteredSystemDetail(systemQuery);
            if (response.isSuccess && response?.data) {
                setSystemDetails(response.data);
            }
        }
        catch (error) { }
    };
    return (_jsxs(React.Fragment, { children: [_jsx(PageHeader, { title: 'Systems', filters: _jsxs(_Fragment, { children: [_jsx(FiltersDiscardButton, { hasNewChanges: isFilterEnabled, handleDiscardFilters: DiscardAndCloseFilters, handleShowFilters: handleEnableFilters }), _jsx(SSearchInput, { onChange: (e) => {
                                setSystemQuery((prev) => ({
                                    ...prev,
                                    searchTerm: e.target.value
                                }));
                            } })] }) }), _jsx(SystemsDataGrid, { rows: systemDetails?.data, fullHeight: true, showFilters: isFilterEnabled, filters: filters, setFilters: setFilters, setSystemQuery: setSystemQuery, systemQuery: systemQuery, totalRows: systemDetails?.totalRecords || 0 }), systemDialog.show && (_jsx(SystemDialog, { isOpen: systemDialog.show, onClose: handleCloseSystemDialog }))] }));
};
export default Systems;
